const RouteNames = {
    DRIVER_DASHBOARD: 'DRIVER_DASHBOARD',
    DISPATCHER: 'DISPATCHER',
    DISPATCHER_SETTINGS: 'DISPATCHER_SETTINGS',
    ORDER_READY: 'ORDER_READY',
}

export default RouteNames;